import EventEmitter from 'events'
import axios from 'axios'

const localStorageKey = 'loggedIn';

const tokenExpiryKey = 'tokenExpiry';
const loginEvent = 'loginEvent';
const authConfig = {
  domain: window.__CONFIG__.auth,
  clientId: window.__CONFIG__.clientID,
}
class AuthService extends EventEmitter {
  idToken = JSON.parse(localStorage.getItem('authToken') || 'null')
  profile = JSON.parse(localStorage.getItem('authProfile') || 'null')
  metadata = JSON.parse(localStorage.getItem('authMetaData') || 'null')
  tokenExpiry = null;
  userinfo = null

  get jwtToken() {
    if (!this.idToken) {
      return undefined
    }
    return this.idToken.token_type + ' ' + this.idToken.access_token
  }

  async _loadMetaData() {
    if (this.metadata) {
      return this.metadata
    }
    const res = await axios.get(`${authConfig.domain}/.well-known/openid-configuration`)
    this.metadata = res.data
    localStorage.setItem('authMetaData', JSON.stringify(this.metadata))
    return this.metadata
  }
  _parseUrlFragment(value, delimiter = "#", global = window) {
    if (typeof value !== 'string') {
      value = global.location.href;
    }

    var idx = value.lastIndexOf(delimiter);
    if (idx >= 0) {
      value = value.substr(idx + 1);
    }

    if (delimiter === "?") {
      // if we're doing query, then strip off hash fragment before we parse
      idx = value.indexOf('#');
      if (idx >= 0) {
        value = value.substr(0, idx);
      }
    }

    var params = {},
      regex = /([^&=]+)=([^&]*)/g,
      m;

    var counter = 0;
    while (m = regex.exec(value)) {
      params[decodeURIComponent(m[1])] = decodeURIComponent(m[2]);
      if (counter++ > 50) {
        Log.error("UrlUtility.parseUrlFragment: response exceeded expected number of parameters", value);
        return {
          error: "Response exceeded expected number of parameters"
        };
      }
    }

    for (var prop in params) {
      return params;
    }

    return {};
  }

  // Starts the user login flow
  login(customState) {
    // webAuth.authorize({
    //     appState: customState
    // });
  }

  // Handles the callback request from Auth0
  async handleAuthentication() {

    const tokeninfo = this._parseUrlFragment(window.location.href)
    console.log(tokeninfo)

    await this._loadMetaData()
    const userRes = await axios.get(this.metadata.userinfo_endpoint, {
      headers: {
        Authorization: `${tokeninfo.token_type} ${tokeninfo.access_token}`
      }
    })
    this.userinfo = userRes.data

    this.localLogin({
      idToken: tokeninfo,
      profile: userRes.data
    });
    return tokeninfo.id_token
  }

  localLogin(authResult) {
    this.idToken = authResult.idToken;
    this.profile = authResult.profile;

    // Convert the JWT expiry time from seconds to milliseconds
    this.tokenExpiry = new Date(Date.now() + (this.idToken.expires_in * 1000));
    localStorage.setItem(tokenExpiryKey, this.tokenExpiry);
    localStorage.setItem(localStorageKey, 'true');
    localStorage.setItem('authProfile', JSON.stringify(this.profile));
    localStorage.setItem('authToken', JSON.stringify(this.idToken));

    const stateData = JSON.parse(atob(this.idToken.state))
    console.log(stateData)

    if (stateData.from && stateData.from.indexOf('http') === 0) {
      window.location.href = stateData.from
    }

    this.emit(loginEvent, {
      loggedIn: true,
      profile: this.profile,
      state: authResult.appState || {}
    });
  }

  async checkOrLogin() {
    // webAuth.signinRedirect()
    if (~window.location.pathname.indexOf('/authcallback')) {
      return 'logging'
    }
    if (!this.isAuthenticated()) {
      await this._loadMetaData()

      const state = btoa(JSON.stringify({ from: window.location.href }))

      const authUrl = `${this.metadata.authorization_endpoint}?client_id=${authConfig.clientId}&response_type=id_token%20token&redirect_uri=${window.location.origin + process.env.BASE_URL + "authcallback"}&scope=openid%20jobInfo%20power%20profile%20mcrs&state=${state}&nonce=${Math.random().toString(36)}&response_mode=fragment`
      window.location.href = authUrl
    }
  }

  async logOut() {
    localStorage.removeItem(localStorageKey);
    localStorage.removeItem(tokenExpiryKey);
    localStorage.removeItem('userInfo');

    await this._loadMetaData()
    window.location.href = `${this.metadata.end_session_endpoint}?id_token_hint=${this.idToken.id_token}&post_logout_redirect_uri=${window.location.origin + (process.env.BASE_URL == '/' ? '' : process.env.BASE_URL)}`
  }

  isAuthenticated() {
    return (
      new Date(Date.now()) < new Date(localStorage.getItem(tokenExpiryKey)) &&
            localStorage.getItem(localStorageKey) === 'true'
    );
  }
}

export default new AuthService();
